import React from 'react';
import TopFiltersContainer from '../TopFilters/TopFiltersContainer';
import MobileFiltersContainer from '../MobileFilters/MobileFiltersContainer';
import JobsContainer from '../Jobs/JobsContainer';
import PropTypes from 'prop-types';

const supplyHeading = () => (
  <div className="supply-search-header">
    <h2 className="heading heading--xl">tes supply</h2>
    <span>Search the latest supply teaching jobs in the UK and across the world</span>
  </div>
);

const searchHeading = (numberOfJobs, pageTitle) => {
  const modifiedPageTitle = pageTitle.replace(/\| TES$/gi, '');

  return (
    <div className="seo-heading">
      <span className="seo-number-of-jobs">{numberOfJobs}</span>
      <h1 className="seo-title">{modifiedPageTitle}</h1>
    </div>
  );
};

export const PageContent = ({ searchType, isMobile, numberOfJobs = 0, pageTitle = '' }) =>
  <div>
    <div className="l-section-wrapper clearfix">
      {searchType === 'supply' && supplyHeading()}
      {(!searchType || searchType === 'search') && searchHeading(numberOfJobs, pageTitle)}
      <TopFiltersContainer />
      {isMobile && <MobileFiltersContainer />}
      <JobsContainer />
    </div>
  </div>;

PageContent.propTypes = {
  searchType: PropTypes.string,
  isMobile: PropTypes.bool,
  numberOfJobs: PropTypes.number,
  pageTitle: PropTypes.string
};

PageContent.defaultProps = {
  isMobile: false
};
